var map = {
	"./box/block.json": 1198,
	"./box_children/block.json": 6886,
	"./column/block.json": 166,
	"./columns/block.json": 2603,
	"./embedded/block.json": 2663,
	"./heading/block.json": 8220,
	"./image/block.json": 7153,
	"./paragraph/block.json": 8351,
	"./svg/block.json": 3596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3849;